import { SHIPIUM_DOMAINS } from '~/utils/shipiumDomain';

export function titleFromSlug() {
  let slug = window.location.pathname.split('/').pop() || '';
  slug = slug.replace(/_/g, '-').replace(/--/g, '-');
  return slug
    .split('-')
    .map((part) => {
      return part.substring(0, 1).toUpperCase() + part.substring(1);
    })
    .join(' ');
}

export function capitalizeFirstLetter(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export enum Environment {
  DEVELOPMENT = 'DEVELOPMENT',
  STAGING = 'STAGING',
  PRODUCTION = 'PRODUCTION',
}

export function getEnvironment(): Environment {
  const isProd = process.env.NODE_ENV === 'production';

  if (isProd) {
    if (/stage/.test(window.location.hostname)) {
      return Environment.STAGING;
    } else {
      return Environment.PRODUCTION;
    }
  } else {
    return Environment.DEVELOPMENT;
  }
}

// Base URL of the admin-console-ui app for the current environment. Only the
// production build targets prod; stage and local dev both point at stage (there
// is no local admin-console to deep-link into).
//
// The admin console is Shipium-staff-only and deployed only in the NA domain,
// so every environment resolves to an NA host regardless of the domain serving
// the console. Revisit once an EU admin console deployment exists.
export function getAdminConsoleBaseUrl(): string {
  const domain = SHIPIUM_DOMAINS.NA;
  return getEnvironment() === Environment.PRODUCTION
    ? `https://admin-console-ui.${domain}`
    : `https://admin-console-ui.stage.${domain}`;
}
